<template>
  <b-modal
    v-if="user.verified"
    ref="modal"
    id="addNewOperationModal"
    header-class="anchor-modal"
    hide-footer
    title="New Experience"
  >
    <vue-form-generator
      ref="formRealEstateOperation"
      :schema="schema"
      :model="model"
    />
    <b-row>
      <b-col class="col-auto ml-auto">
        <add-asset-button
          id="extra-asset"
          style-class-row="pr-3"
          button-text="Save"
          @submit="saveNewOperation"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import helper from '@/libs/helper';
import AddAssetButton from '@/components/utils/buttons/misc/AddAssetButton';
import REAL_ESTATE_OPERATION_MODEL from '@/components/profile/sections/tabs/real_estate/resources/realEstateOperation';
import REAL_ESTATE_OPERATION_SCHEMA from '@/components/profile/sections/tabs/real_estate/schemas/operationSchema';
import { DEFINE_PROFILE_REAL_ESTATE_OPERATION } from '@/vuex/modules/profile/types/actions';

export default {
  name: 'RealEstateOperationModal',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    AddAssetButton,
  },
  data() {
    return {
      model: helper.copy(REAL_ESTATE_OPERATION_MODEL),
      schema: REAL_ESTATE_OPERATION_SCHEMA.schema(
        this.saveNewOperation,
      ),
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    saveNewOperation(extraItem) {
      if (!this.isExperienceFormValid()) {
        return;
      }
      const data = {
        ...this.model,
      };
      this.$reqs
        .post(`/users/${this.user.id}/profile/real_estate_operation`, data)
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_REAL_ESTATE_OPERATION, {
            realEstateOperation: response.data.realEstateOperation,
          });
          this.$emit('success');
          this.model = {};
          if (extraItem) {
            this.hide();
            this.show();
          } else {
            this.hide();
          }
        })
        .catch(() => {});
    },
    isExperienceFormValid() {
      return this.$refs.formRealEstateOperation.validate();
    },
    clearValidationErrors() {
      this.$refs.formRealEstateOperation.clearValidationErrors();
    },
    show() {
      const modal = this.$refs.modal;
      if (modal) {
        modal.show();
      }
    },
    hide() {
      const modal = this.$refs.modal;
      if (modal) {
        modal.hide();
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/real_estate/RealEstateOperationModal.vue